import RightRail, { Content, Footer, Header } from '../../libs/gs-component-right-rail';
import React from 'react';

import { WeddingWebsiteQuery } from '../../generated/graphql';
import DoubleActionWithError from '../FormComponents/DoubleActionWithError';
import ChangeThemeRail from './ChangeThemeRail';
import styles from './liteSitePreview.scss';

interface Props {
  previewThemeId: number | null;
  rightRailOpen: boolean;
  resetThemeToCurrent: () => void;
  previewThemeCallback: (id: number) => void;
  wwsData?: WeddingWebsiteQuery;
  updatingTheme: boolean;
  showErrorToast: boolean;
  setThemeToCurrentPreview: () => Promise<void>;
  onEscapeKey?: () => void;
}

const ChangeTheme: React.FC<Props> = ({
  previewThemeId,
  rightRailOpen,
  resetThemeToCurrent,
  previewThemeCallback,
  wwsData,
  updatingTheme,
  showErrorToast,
  setThemeToCurrentPreview,
  onEscapeKey,
}) => {
  const isPublished = wwsData?.weddingWebsite?.state === 'published';
  return (
    <div className={!!previewThemeId ? styles.rightRailPreviewActive : ''}>
      <RightRail open={rightRailOpen} overlay={false} className={styles.rightRail} onEscapeKey={onEscapeKey}>
        <Header onClose={resetThemeToCurrent} as="h1">
          <div>Change design</div>
        </Header>
        <Content>
          <ChangeThemeRail
            previewTheme={previewThemeCallback}
            currentThemeId={wwsData?.weddingWebsite.themeId || null}
            selectedThemeId={previewThemeId}
          />
        </Content>
        {!!previewThemeId ? (
          <Footer>
            <div data-testid="previewRightRailFooter">
              <DoubleActionWithError
                primaryText={isPublished ? 'Save & publish' : 'Save'}
                secondaryText="Cancel"
                primaryOnClick={setThemeToCurrentPreview}
                secondaryOnClick={resetThemeToCurrent}
                errorText="Something went wrong! Your theme has not been updated."
                showSpinner={updatingTheme}
                showError={showErrorToast}
              />
            </div>
          </Footer>
        ) : null}
      </RightRail>
    </div>
  );
};

export default ChangeTheme;
